// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"08b88e3e","238":"292db4b5","492":"37f9ca79","510":"52dbbb05","577":"c2bc4733","726":"4a4d2a54","777":"0360695e","886":"0068a928"}[chunkId] + ".chunk.js";
};